import { render, staticRenderFns } from "./releaseActivities.vue?vue&type=template&id=187c028b&scoped=true"
import script from "./releaseActivities.vue?vue&type=script&lang=js"
export * from "./releaseActivities.vue?vue&type=script&lang=js"
import style0 from "./releaseActivities.vue?vue&type=style&index=0&id=187c028b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c028b",
  null
  
)

export default component.exports